/**
 * main.ts
 *
 * @version
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.26.0 OAUI-416 Add basic QR code order management route
 * 4.23.0 OAUI-408 Paginating in Work Orders is slow
 * 4.22.0 OAUI-390 Billing Report: build Angular UI
 *
 * @author Luis Hernandez <lhernandez@intersog.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { setAngularJSGlobal } from '@angular/upgrade/static';
import * as angular from 'angular';

if (environment.production) {
  enableProdMode();
}

setAngularJSGlobal(angular);
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
